import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from '@99designs/common/components/Spinner';
import classNames from 'classnames';

export default class Button extends React.Component {
    constructor(props) {
        super(props);
    }

    getClasses() {
        let classes = classNames(
            'button',
            {
                'button--cta-link': this.props.ctaLink,
                'button--dropdown': this.props.dropdown,
                'button--jumbo': this.props.size === 'jumbo',
                'button--marketing-secondary': this.props.variation === 'marketing-secondary',
                'button--primary': this.props.variation === 'primary',
                'button--responsive': this.props.responsive,
                'button--fluid': this.props.fluid,
                'button--secondary': this.props.variation === 'secondary',
                'button--link': this.props.variation === 'link',
            },
            this.props.className
        );

        if (this.props.color) {
            classes += ` button--${this.props.color}`;
        }

        if (this.props.iconAlignment) {
            classes += ` button--icon-${this.props.iconAlignment}`;
        } else if (this.props.icon) {
            classes += ' button--icon';
        }

        return classes;
    }

    attributes() {
        let { href, target } = this.props;

        return {
            href,
            target,
            disabled: this.props.disabled || this.props.saving,
            type: this.props.typeAttribute,
        };
    }

    render() {
        let ButtonType = this.props.href ? 'a' : 'button';
        let ButtonLabel = <span className="button__label">{this.props.children}</span>;
        let ButtonIconContent = this.props.saving ? (
            <Spinner variations={['inline', 'small']} />
        ) : (
            this.props.icon
        );
        let ButtonIcon = ButtonIconContent && (
            <span className="button__icon">{ButtonIconContent}</span>
        );

        return (
            <ButtonType
                {...this.attributes()}
                onClick={this.props.onClick}
                className={this.getClasses()}
            >
                <span className="button__inner">
                    {this.props.iconAlignment === 'left' && ButtonIcon}
                    {this.props.children && ButtonLabel}
                    {this.props.iconAlignment === 'right' && ButtonIcon}
                </span>
            </ButtonType>
        );
    }
}

Button.defaultProps = {
    size: 'default',
    variation: null,
};

Button.propTypes = {
    variation: PropTypes.oneOf(['primary', 'secondary', 'marketing-secondary', 'link']),
    responsive: PropTypes.bool,
    fluid: PropTypes.bool,
    href: PropTypes.string,
    iconAlignment: PropTypes.oneOf(['left', 'right']),
    icon: PropTypes.element,
    color: PropTypes.string,
    dropdown: PropTypes.bool,
    ctaLink: PropTypes.bool,
    typeAttribute: PropTypes.oneOf(['submit', 'button']),
    size: PropTypes.oneOf(['jumbo', 'default']).isRequired,
};



// WEBPACK FOOTER //
// ./js/common/components/Button.jsx